import { Form } from 'antd';

import { ExperienceType } from 'app/typings/experiences';

import { GuestConfiguration } from './GuestConfiguration';
import { OvernightRule } from './OvernightRule';
import { PriceConfiguration } from './PriceConfiguration';
import { StockConfiguration } from './StockConfiguration';

export const Availability = () => {
  const form = Form.useFormInstance();
  const isOriginal =
    Form.useWatch('experienceType', form) === ExperienceType.STAYCATION;

  return (
    <>
      {!isOriginal && <OvernightRule />}
      <GuestConfiguration />
      {!isOriginal && <StockConfiguration />}
      <PriceConfiguration />
    </>
  );
};
